// Exact defaults published before the macro book redesign. Migration only.
export const thanksBeingLatePrevious = {
  "title": "Thank You for Being Late — l’humain dans l’accélération",
  "family": "Culture & humains",
  "importance": "critique",
  "ownerIds": [
    "db",
    "ed",
    "eh",
    "rd"
  ],
  "tags": [
    "TKS",
    "Thank You for Being Late",
    "IA",
    "humain",
    "adaptation"
  ],
  "summary": "Distinguer la thèse de Friedman, les enseignements des recherches sur l’IA et une orientation humaine de transformation à discuter au CE.",
  "whyNow": "Apprendre à transformer les pratiques sans confondre vitesse, adoption d’outils et progrès humain.",
  "enrichedContext": [
    "Friedman : trois accélérations — technologie, mondialisation et environnement — et une réponse par la réflexion, l’adaptation et les communautés.",
    "Autour de 2007 : un repère de convergence chez l’auteur, pas le début de toute accélération ni une causalité démontrée.",
    "L’IA figure déjà dans son propos; la vague actuelle d’IA générative ne doit pas être attribuée à cet essai de 2016.",
    "Le récit de lecture et la position stratégique sont chargés séparément après autorisation CE."
  ],
  "questions": [
    "Quel besoin humain choisir pour un premier essai limité?",
    "Qui accompagner, avec quel temps protégé et quel responsable?",
    "Quels signes de qualité, de charge et de confiance observer?",
    "Quand corriger, arrêter ou élargir une expérimentation?"
  ],
  "decisions": [
    "Discuter une orientation humaine du changement, sans présenter la réflexion comme déjà approuvée.",
    "Définir les garde-fous, le soutien et les moyens avant d’élargir.",
    "Choisir un usage utile et réversible avec les personnes concernées.",
    "Convenir d’un moment de bilan et conserver les apprentissages."
  ],
  "signals": [
    "Adoption ne signifie pas transformation réussie.",
    "L’hésitation peut refléter des besoins de compétences, de sécurité ou de pertinence.",
    "La transformation ne justifie ni la désorganisation ni l’épuisement."
  ],
  "evidence": [
    "Thomas L. Friedman : présentation du livre et conférence Carnegie Council (2017).",
    "OCDE : Generative AI and the SME Workforce (2025); NBER WP 33795 (2025).",
    "McKinsey : How organizations are rewiring to capture value (2025); liens et limites dans Sources."
  ]
};
